import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Spinner, Card, CardHeader, Row, Col, CardBody } from 'reactstrap';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { GetAssetDomain, GetAPIDomain } from '../../infrastructure/Helper';
import { WellStreamUserClient } from '../../infrastructure/WellStreamClient/Users';

export class CustomersEdit extends Component {

    constructor(props) {
        super(props);
        this.state = { init: false, make: "", model: "", loading: true, authenticated: true, next: false, name: "", description: "" };

    }

    componentDidMount() {
        this.populateData(this.props.match.params.id);
    }

    renderForm() {
        if (this.state.loading) {
            return (
                <h4><i>Loading...</i></h4>);
        } else {

            return (<Formik
                initialValues={{
                    name: this.state.name,
                    surname: this.state.surname,
                    mobile: this.state.mobile,
                    email: this.state.email
                }}
                onSubmit={async (fields, { setErrors, setFieldError }) => {


                    if (!fields.name) {
                        setFieldError("name", "Please specify the name");
                        return;
                    }

                    if (!fields.surname) {
                        setFieldError("surname", "Please specify the surname");
                        return;
                    }

                    if (!fields.email) {
                        setFieldError("email", "Please specify the email");
                        return;
                    }

                    var profileImageId = this.state.profileImageId;

                    if (fields.file) {

                        let formData = new FormData();
                        formData.append("file", fields.file);

                        var imageResult = await fetch((await GetAPIDomain()) + "/uploads/images", {
                            method: 'post',
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem("acess-token")
                            },
                            body: formData
                        });

                        if (imageResult.ok) {
                            profileImageId = (await imageResult.json()).id;
                        }
                    }

                    var response = await WellStreamUserClient.Update(this.props.match.params.id, fields.name, fields.surname, fields.email, fields.mobile, profileImageId);

                    if (!response.successful) {

                        if (response.status === 404) {
                            this.setState({ next: true });
                        } else {

                            response.validationErrors.map(error => {
                                setFieldError(error.key, error.message);
                                return {
                                    [error.key]: error.message
                                };
                            });
                        }

                    } else {
                        this.setState({ next: true });
                    }

                }}
            >{({ errors, handleChange, handleBlur, status, touched, isSubmitting, values, setFieldValue, setFieldTouched }) => (
                <Form>
                    <Row>
                        <Col>
                                <Row>
                                    <Col>
                                        <div className="form-group">
                                            <label htmlFor="name">Name*</label>
                                            <Field name="name" placeholder="John" type="text" className={'bgWhite form-control' + (errors.name && touched.name ? ' is-invalid' : '')} />
                                            <ErrorMessage name="name" component="div" className="invalid-feedback text-left" />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="form-group">
                                            <label htmlFor="surname">Surname*</label>
                                            <Field name="surname" placeholder="John" type="text" className={'bgWhite form-control' + (errors.surname && touched.surname ? ' is-invalid' : '')} />
                                            <ErrorMessage name="surname" component="div" className="invalid-feedback text-left" />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="form-group">
                                            <label htmlFor="email">Email*</label>
                                            <Field name="email" placeholder="email@thewellstream.com" type="text" className={'bgWhite form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                                            <ErrorMessage name="email" component="div" className="invalid-feedback text-left" />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="form-group">
                                            <label htmlFor="mobile">Mobile</label>
                                            <Field name="mobile" placeholder="02....." type="text" className={'bgWhite form-control' + (errors.mobile && touched.mobile ? ' is-invalid' : '')} />
                                            <ErrorMessage name="mobile" component="div" className="invalid-feedback text-left" />
                                        </div>
                                    </Col>
                                </Row>
                        </Col>
                        <Col md="3" className="text-center">
                            <div className="form-group">
                                <h6 className="text-left">Profile image</h6>

                                {this.state.file && <div>
                                    <img alt="Uploaded supporting file" src={this.state.file} style={{ width: "250px", marginTop: "20px", objectFit: "cover" }} />
                                </div>}

                                <input style={{ "overflow": "hidden", marginTop: "25px" }} className="form-control-file" id="file" name="file" type="file" onChange={(event) => {

                                    this.setState({
                                        file: URL.createObjectURL(event.target.files[0])
                                    })
                                    setFieldValue("file", event.currentTarget.files[0]);
                                }} />

                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <hr />

                            <div className="form-group mt-3">
                                <button type="submit" className="btn mr-2 btn-outline-dark mt-2" disabled={isSubmitting}>
                                    {!isSubmitting && "SAVE"}
                                    {isSubmitting && <Spinner animation="border" />}
                                </button>
                            </div>

                        </Col>

                    </Row>
                </Form>
            )}</Formik>);
        }
    }

    render() {
        if (this.state.next === true) {
            return (<Redirect to={"/customers/details/" + this.props.match.params.id} />);
        } else if (!this.state.authenticated) {
            return (<Redirect to="/sign-in" />);
        } else {
            return (
                <div>

                    <Card>
                        <CardHeader>
                            <Row>
                                <Col>
                                    <h5> Update user
                                     {this.state.loading && <Spinner style={{ height: "18px", width: "18px", marginLeft: "10px" }} animation="border" />}
                                    </h5>
                                    <span className="d-block m-t-5 text-muted">Update details about the user</span>
                                </Col>
                                <Col>
                                    <div style={{ paddingRight: "10px" }}>
                                        <Link style={{ float: "right" }} to={"/customers/details/" + this.props.match.params.id} className="btn mr-2 btn-outline-dark mt-2 mb-2">Cancel</Link>
                                    </div>
                                </Col>
                            </Row>

                        </CardHeader>

                        <CardBody>
                            {this.renderForm(this.state.data)}
                        </CardBody>
                    </Card>
                </div>
            );
        }
    }

    async populateData(id) {
        if (!this.state.init) {
            this.setState({ init: true });

            var response = await WellStreamUserClient.Get(id);

            if (!response.authenticated) {
                this.setState({
                    loading: false,
                    authenticated: false
                });
            } else {

                if (response.data.profileImage) {
                    this.setState({
                        file: (await GetAssetDomain()) + "/image/" + response.data.profileImage.id + ".jpg"
                    });
                }

                this.setState({
                    loading: false,
                    name: response.data.name,
                    surname: response.data.surname,
                    email: response.data.email,
                    mobile: response.data.mobile,
                    profileImageId: response.data.profileImage ? response.data.profileImage.id : null
                });
            }
        }
    }
}
